<script>
import List from "@/components/molecules/list";
import ListItem from "@/components/molecules/list/list-item";
import DefiCardOverview from "@/containers/defi-card-overview";
import Button from "@/components/atoms/button";

export default {
  name: "DefisListe",
  components: {
    DefiCardOverview,
    List,
    ListItem,
    Button
  },
  props: {
    defis: {
      type: Array,
      required: false,
      default: () => []
    },
    typeCarte: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      numberToDisplay: 6
    };
  },
  computed: {
    defisListeDisplay() {
      return this.defis.slice(0, this.numberToDisplay);
    }
  }
};
</script>

<template>
  <div>
    <List class="c-defis-liste">
      <ListItem
        v-for="defi in defisListeDisplay"
        :key="defi.id"
        class="c-defis-liste__item"
      >
        <DefiCardOverview
          :defi="defi"
          :type-carte="typeCarte"
          class="u-full-height"
        />
      </ListItem>
    </List>
    <div
      v-if="defis.length > numberToDisplay"
      class="u-text-center"
    >
      <Button
        size="lg25"
        radius="full"
        variant="primary"
        class="u-mt-md"
        @click="numberToDisplay = numberToDisplay + 6"
      >
        Voir plus de défis
      </Button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/defis-liste.scss";
</style>
